import Mood from './Mood'
import React, { useEffect, useRef, useState } from 'react'
import { collection, updateDoc, doc, setDoc, addDoc, Timestamp, serverTimestamp } from 'firebase/firestore'
import { auth, db } from '../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import { Link } from 'react-router-dom'
import {FiChevronRight,FiChevronLeft } from 'react-icons/fi';
import {AiFillTag} from 'react-icons/ai';

const Entry = ({userTags}) => {

    const [pleasantness, setPleassantness] = useState(0)
    const [energy, setEnergy] = useState(0)

    const [title, setTitle] = useState("")
    const [desc, setDesc] = useState("")
    const [emotions, setEmotions] = useState([])
    const [emotionNames, setEmotionNames] = useState([])
    const [tags, setTags] = useState([])
    const [evaluationGood, setEvaluationGood] = useState("")
    const [evaluationBad, setEvaluationBad] = useState("")
    const [analyzeEmo, setAnalyzeEmo] = useState("")
    const [impact, setImpact] = useState("")
    const [learnYourself, setLearnYourself] = useState("")
    const [alternatives, setAlternatives] = useState("")
    const [actionPlan, setActionPlan] = useState("")
    const [averageP, setAverageP] = useState(0)
    const [averageE, setAverageE] = useState(0)
    const [keywords, setKeywords] = useState([])

    const [user] = useAuthState(auth)

    const hScrollableRef = useRef(null)


    

    function scrollToTop() {
      window.scrollTo(0, 0);
    }
 

    const scrollLeft =()=>{
      if(hScrollableRef.current){
        hScrollableRef.current.scrollBy({
          left: -200,
          behavior: "smooth"
        });
      }
    }

    const scrollRight =()=>{
      if(hScrollableRef.current){
        hScrollableRef.current.scrollBy({
          left: 200,
          behavior: "smooth"
        });
      }
    }
    
    useEffect(()=>{
      
      scrollToTop()
      

    },[])


    const redWords = [
        "enraged", "panicked", "stressed", "jittery", "shocked",
        "livid", "furious", "frustrated", "tense", "stunned",
        "fuming", "frightened", "angry", "nervous", "restless",
        "anxious", "apprehensive", "worried", "irritaed", "annoyed",
        "repulsed", "troubled", "concered", "uneasy", "peeved"
        ]
    
    const yellowWords = [
        "surprised", "upbeat", "festive", "exhilarated", "ecstatic",
        "hyper", "cheerful", "motivated", "inspired", "elated",
        "energized", "lively", "enthusiastic", "optimistic", "excited",
        "pleased", "happy", "focused", "proud", "thrilled",
        "pleasant", "joyful", "hopeful", "playful", "blistful"
    ] 

    const blueWords = [
        "disgusted", "glum", "disappointed", "down", "apathetic",
        "pessimistic", "morose", "discouraged", "sad", "bored",
        "alienated", "miserable", "lonely", "disheartened", "tired",
        "despondent", "depressed", "sullen", "exhausted", "fatigued",
        "despair", "hopeless", "desolate", "spent", "drained"
    ]

    const greenWords = [
        "at ease", "easygoing", "content", "loving", "fulfilled",
        "calm", "secure", "satisfied", "grateful", "touched",
        "relaxed", "chill", "restful", "blessed", "balanced",
        "mellow", "thoughtful", "peaseful", "comfy", "carefree",
        "sleepy", "complacent", "tranquil", "cozy", "serene"

    ]

    const redList = [
        {name: "enraged", pleasantness: -5, energy: 1},
        {name: "panicked", pleasantness: -4, energy: 1},
        {name: "stressed", pleasantness: -3, energy: 1},
        {name: "jittery", pleasantness: -2, energy: 1},
        {name: "shocked", pleasantness: -1, energy: 1},
        {name: "livid", pleasantness: -5, energy: 2},
        {name: "furious", pleasantness: -4, energy: 2},
        {name: "frustrated", pleasantness: -3, energy: 2},
        {name: "tense", pleasantness: -2, energy: 2},
        {name: "stunned", pleasantness: -1, energy: 2},
        {name: "fuming", pleasantness: -5, energy: 3},
        {name: "frightened", pleasantness: -4, energy: 3},
        {name: "angry", pleasantness: -3, energy: 3},
        {name: "nervous", pleasantness: -2, energy: 3},
        {name: "restless", pleasantness: -1, energy: 3},
        {name: "anxious", pleasantness: -5, energy: 2},
        {name: "apprehensive", pleasantness: -4, energy: 2},
        {name: "worried", pleasantness: -3, energy: 2},
        {name: "irritaed", pleasantness: -2, energy: 2},
        {name: "annoyed", pleasantness: -1, energy: 2},
        {name: "repulsed", pleasantness: -5, energy: 1},
        {name: "troubled", pleasantness: -4, energy: 1},
        {name: "concered", pleasantness: -3, energy: 1},
        {name: "uneasy", pleasantness: -2, energy: 1},
        {name: "peeved", pleasantness: -1, energy: 1}
    ]

    const yellowList = [
        {name: "surprised", pleasantness: 1, energy: 5},
        {name: "upbeat", pleasantness: 2, energy: 5},
        {name: "festive", pleasantness: 3, energy: 5},
        {name: "exhilarated", pleasantness: 4, energy: 5},
        {name: "ecstatic", pleasantness: 5, energy: 5},
        {name: "hyper", pleasantness: 1, energy: 4},
        {name: "cheerful", pleasantness: 2, energy: 4},
        {name: "motivated", pleasantness: 3, energy: 4},
        {name: "inspired", pleasantness: 4, energy: 4},
        {name: "elated", pleasantness: 5, energy: 4},
        {name: "energized", pleasantness: 1, energy: 3},
        {name: "lively", pleasantness: 2, energy: 3},
        {name: "enthusiastic", pleasantness: 3, energy: 3},
        {name: "optimistic", pleasantness: 4, energy: 3},
        {name: "excited", pleasantness: 5, energy: 3},
        {name: "pleased", pleasantness: 1, energy: 2},
        {name: "happy", pleasantness: 2, energy: 2},
        {name: "focused", pleasantness: 3, energy: 2},
        {name: "proud", pleasantness: 4, energy: 2},
        {name: "thrilled", pleasantness: 5, energy: 2},
        {name: "pleasant", pleasantness: 1, energy: 1},
        {name: "joyful", pleasantness: 2, energy: 1},
        {name: "hopeful", pleasantness: 3, energy: 1},
        {name: "playful", pleasantness: 4, energy: 1},
        {name: "blistful", pleasantness: 5, energy: 1},


    ]

    const blueList = [
        {name: "disgusted", pleasantness: -5, energy: -1},
        {name: "glum", pleasantness: -4, energy: -1},
        {name: "disappointed", pleasantness: -3, energy: -1},
        {name: "down", pleasantness: -2, energy: -1},
        {name: "apathetic", pleasantness: -1, energy: -1},
        {name: "pessimistic", pleasantness: -5, energy: -2},
        {name: "morose", pleasantness: -4, energy: -2},
        {name: "discouraged", pleasantness: -3, energy: -2},
        {name: "sad", pleasantness: -2, energy: -2},
        {name: "bored", pleasantness: -1, energy: -2},
        {name: "alienated", pleasantness: -5, energy: -3},
        {name: "miserable", pleasantness: -4, energy: -3},
        {name: "lonely", pleasantness: -3, energy: -3},
        {name: "disheartened", pleasantness: -2, energy: -3},
        {name: "tired", pleasantness: -1, energy: -3},
        {name: "despondent", pleasantness: -5, energy: -4},
        {name: "depressed", pleasantness: -4, energy: -4},
        {name: "sullen", pleasantness: -3, energy: -4},
        {name: "exhausted", pleasantness: -2, energy: -4},
        {name: "fatigued", pleasantness: -1, energy: -4},
        {name: "despair", pleasantness: -5, energy: -5},
        {name: "hopeless", pleasantness: -4, energy: -5},
        {name: "desolate", pleasantness: -3, energy: -5},
        {name: "spent", pleasantness: -2, energy: -5},
        {name: "drained", pleasantness: -1, energy: -5},

    ]

    const greenList = [
        {name: "at ease", pleasantness: 1, energy: -1},
        {name: "easygoing", pleasantness: 2, energy: -1},
        {name: "content", pleasantness: 3, energy: -1},
        {name: "loving", pleasantness: 4, energy: -1},
        {name: "fulfilled", pleasantness: 5, energy: -1},
        {name: "calm", pleasantness: 1, energy: -2},
        {name: "secure", pleasantness: 2, energy: -2},
        {name: "satisfied", pleasantness: 3, energy: -2},
        {name: "grateful", pleasantness: 4, energy: -2},
        {name: "touched", pleasantness: 5, energy: -2},
        {name: "relaxed", pleasantness: 1, energy: -3},
        {name: "chill", pleasantness: 2, energy: -3},
        {name: "restful", pleasantness: 3, energy: -3},
        {name: "blessed", pleasantness: 4, energy: -3},
        {name: "balanced", pleasantness: 5, energy: -3},
        {name: "mellow", pleasantness: 1, energy: -4},
        {name: "thoughtful", pleasantness: 2, energy: -4},
        {name: "peaseful", pleasantness: 3, energy: -4},
        {name: "comfy", pleasantness: 4, energy: -4},
        {name: "carefree", pleasantness: 5, energy: -4},
        {name: "sleepy", pleasantness: 1, energy: -5},
        {name: "complacent", pleasantness: 2, energy: -5},
        {name: "tranquil", pleasantness: 3, energy: -5},
        {name: "cozy", pleasantness: 4, energy: -5},
        {name: "serene", pleasantness: 5, energy: -5}
    ]

    const saveData = async () => {
     
     if (user){

      
      const usersCollection = collection(db, "users")
      //const userRef = doc(usersCollection, user.uid)
      const entriesRef = collection(usersCollection, user.uid, "entries")
      const date = new Date()

 


      await addDoc(entriesRef, {

        date: date,
        title: title,
        desc: desc,
        emotions: emotions,
        emotionNames: emotionNames,
        evaluationGood: evaluationGood,
        evaluationBad: evaluationBad,
        analyzeEmo: analyzeEmo,
        impact: impact,
        learnYourself: learnYourself,
        alternatives: alternatives,
        actionPlan: actionPlan,
        pleasantness: pleasantness,
        energy: energy,
        tags: tags,


      })

     }

    }

    function calcAverage (emotions) {
      let totalP = 0
      let totalE = 0

      emotions.forEach((emo)=>{
        totalP += emo.pleasantness
        totalE += emo.energy
      })

      setPleassantness(totalP/(emotions.length))
      setEnergy(totalE/(emotions.length))
      console.log("size: "+ emotions.length + " P: " + totalP + " E: " + totalE)
    }
/*
    function addEmotion (mood) {

      if(!emotionNames.includes(mood.name)){
      setEmotions([...emotions, mood])
      setEmotionNames([...emotionNames, mood.name])
      calcAverage(emotions)
    
      console.log(emotions)}
    }
*/

    function addEmotion(mood) {
      if (!emotionNames.includes(mood.name)) {
        setEmotions((prevEmotions) => {
          const newEmotions = [...prevEmotions, mood];
          setEmotionNames([...emotionNames, mood.name]);
          calcAverage(newEmotions); // Call calcAverage after setting emotions
          console.log(newEmotions); // Log the updated emotions
          return newEmotions;
        });
      }
    }

    function addTag(tag){
      setTags((prevTags)=>{
        const newTags = [...prevTags, tag]
        return newTags
      })
    }

    function removeTag(tagToRemove){
      setTags((prevTags)=>{
        const newTags = tags.filter((tag)=> tag != tagToRemove)
        return newTags
      })
    }

 
    function removeEmotion(itemToRemove) {
      setEmotions((prevEmotions) => {
        const updatedItems = prevEmotions.filter((item) => item !== itemToRemove);
        setEmotionNames((prevEmotionNames) => {
          const updatedItemNames = prevEmotionNames.filter(
            (item) => item !== itemToRemove.name
          );
          // Now that both state updates are complete, you can call calcAverage
          calcAverage(updatedItems);
          return updatedItemNames;
        });
        return updatedItems;
      });
    }
    
      const [moodMeter] = useState([])

    
      function makeMoodMeter (list, pls, eng) {
        let pleasantness = pls
        let energy = eng
        let string = ""
    
        list.forEach(element => {
    
          moodMeter.push({
            name: element,
            pleasantness: pleasantness, 
            energy: energy 
          })

          string += `{name: "${element}", pleasantness: ${pleasantness}, energy: ${energy}},\n`
    
          if (pleasantness===pls+4) pleasantness = pls
          else pleasantness += 1
    
          if(energy===eng-4) energy = eng
          else energy -= 1
    
        });
    
        console.log(string)
    
      }
      


  return (
  
  <div className='main'>
    <h2>NEW REFLECTION RECORD</h2>
    <h3>Title / summary</h3>
    <p>Set a short and explanatory title to help looking back to this entry.</p>
    <textarea className='txt-area v-fit' onChange={(e)=>{setTitle(e.target.value)}}/>

    <h3>Keywords/Tags</h3>
    <p>Select keywords (topics) to index or organize records by keywords. 
    </p>

   
    <div className='txt-area v-fit'>
      {
       userTags.map((tag)=>(
        <button className='btn' onClick={()=>{addTag(tag)}}>{tag}
        </button>
       ))
      }
    </div>

    <div className='txt-area v-fit'>
        {
          tags.map((tag)=>(
            <button className='btn' onClick={()=>{removeTag(tag)}}>{tag}
            </button>
           ))
        }
        </div>

    <h3>Description of the moment</h3>
    <span className='req'>*required</span>
    <p>
      What happened during the advising session?
      Include as much detail as you think is relevant<br/><br/>
      <span className='italic'>Hints: Who was there? When did it happen? How long did it last? What were you and the advisee doing and saying?</span>
    </p>
    <textarea className='txt-area' onChange={(e)=>{setDesc(e.target.value)}}></textarea>

    <h3>Your emotions</h3>
    <span className='req'>*required</span>
    <p>Use the mood meter to identify up to three emotions you felt during the moment.
      <br/><br/>
      Select the ones that best represent your emotions. Multiple selection possible. 
    </p>
    {
        emotions.length>0&&<label>*Tap/click to deselect</label>
    }
    <div className='txt-area v-fit'>
      {
        emotions.map((mood, index)=>(
          <button 
          onClick={()=>{removeEmotion(mood)}}
          key={index} className={`btn ${mood.pleasantness>0?mood.energy>0?"yellow":"green":mood.energy>0?"red":"blue"}`}>{mood.name}</button>
        ))
      }
      
    </div>
    
      {
        user.email=="sinaka10024@gmail.com"&&
        <>P: {pleasantness}, E: {energy}</>
      }
   
    <div className='mood-meter-container'>

        
          {/*
                <div className="scale-container">
                    <label style={{"textAlign":"right"}}>Negative</label>
                    <input 
                    onChange={(e)=>{setPleassantness(e.target.value)}}
                    className='scale' type='range' min="1" max="10" 
                    value={pleasantness}></input>
                    <label>Positive</label>
                </div>
                */
            }
                
            <div  className='mood-meter' ref={hScrollableRef}>
           
            <div className='grid-container' >

                <div className='grid'>
                    {
                        
                        redList.map((mood, index)=>(

                            <button 
                            onClick={()=>{addEmotion(mood)}}
                            className={`grid-item  ${emotionNames.includes(mood.name)?"selected":mood.pleasantness>0?mood.energy>0?"yellow":"green":mood.energy>0?"red":"blue"}`} key={index}>
                                {mood.name}
                                
                            </button>
                            
                        ))
                        
                        
                    }
                </div>
                <div className='grid pleasant'>
                    {
                        
                        yellowList.map((mood, index)=>(

                            <button 
                              onClick={()=>{addEmotion(mood)}}
                              className={`grid-item ${emotionNames.includes(mood.name)?"selected":mood.pleasantness>0?mood.energy>0?"yellow":"green":mood.energy>0?"red":"blue"}`} key={index}>
                                {mood.name}
                                
                            </button>
                            
                        ))
                        
                        
                    }
                </div>

                <div className='grid'>
                    {
                        
                        blueList.map((mood, index)=>(

                            <button
                              onClick={()=>{addEmotion(mood)}} 
                              className={`grid-item ${emotionNames.includes(mood.name)?"selected":mood.pleasantness>0?mood.energy>0?"yellow":"green":mood.energy>0?"red":"blue"}`} key={index}>
                                {mood.name}
                                
                            </button>
                            
                        ))
                        
                        
                    }
                </div>

                <div className='grid pleasant'>
                    {
                        
                        greenList.map((mood, index)=>(

                            <button
                              onClick={()=>{addEmotion(mood)}} 
                              className={`grid-item ${emotionNames.includes(mood.name)?"selected":mood.pleasantness>0?mood.energy>0?"yellow":"green":mood.energy>0?"red":"blue"}`} key={index}>
                                {mood.name}
                                
                            </button>
                            
                        ))
                        
                        
                    }
                </div>

             
            </div>
            
            
            </div>
            <div className=' mood-text vertical'>+ Energy -</div>
            
            

      </div>
      <div className='mood-text-container'> 
        <button className='btn scroll-left' onClick={scrollLeft}><FiChevronLeft fontSize="20px"/></button>
        <div className='mood-text'>- Pleasantness +</div>
        <button className='btn scroll-right' onClick={scrollRight}><FiChevronRight fontSize="20px"/></button>
      </div>
      
      
      <h3>Evaluation of the session</h3>

        <p>What do you think went well in the session?</p>
        <textarea className='txt-area' onChange={(e)=>{setEvaluationGood(e.target.value)}}></textarea>

        <p>What do you think did not go well in the session?</p>
        <textarea className='txt-area' onChange={(e)=>{setEvaluationBad(e.target.value)}}></textarea>

      <h3>Analysis</h3>

        <p>Why do you think these emotions came up for you during the session?</p>
        
        <div className='txt-area v-fit transparent'>
          {
            emotions.map((mood, index)=>(
              <button 
              
              key={index} className={`btn ${mood.pleasantness>0?mood.energy>0?"yellow":"green":mood.energy>0?"red":"blue"}`}>{mood.name}</button>
            ))
          }
          
        </div>

        <textarea className='txt-area' onChange={(e)=>{setAnalyzeEmo(e.target.value)}}></textarea>

        <p>What can you learn about yourself through this experience, if anything?</p>
        <textarea className='txt-area' onChange={(e)=>{setLearnYourself(e.target.value)}}></textarea>

      <h3>Conclusions/Alternatives</h3> 
      <p>What are some other ways that you could have handled this session, if any? If you did that, how would it impact your emotions (if at all)?</p>
      <textarea className='txt-area' onChange={(e)=>{setAlternatives(e.target.value)}}></textarea>

      <h3>Action plan</h3>
      <p>Based on what you have learned about yourself through this reflection, what actions would you like to take in the future?</p>
      <textarea className='txt-area' onChange={(e)=>{setActionPlan(e.target.value)}}></textarea>

      <Link className='link' to={`/`}>
          <button className='btn hover-circle negative fixed-bl'>
            Cancel
          </button>
        </Link>
     
        <Link className='link' to={desc!=""&&emotions.length>0&&`/`}>
          <button className={`btn hover-circle fixed-br inactive ${desc!=""&&emotions.length>0&&"positive"}`} onClick={()=>{if(desc!=""&&emotions.length>0){saveData()}}}>
            Save
          </button>
        </Link>

    </div>
  )
}

export default Entry